import React from 'react';

const Header = () => (
  <header className="header">
    <h1>Resume Analyzer</h1>
    <p>Upload your resume and job description to get personalized insights</p>
  </header>
);

export default Header; 


// WEBPACK FOOTER //
// ./src/components/Header.js